<script setup lang="ts">
import { computed } from "vue";

import { cardKey } from "@/components/StickyNote/injectKeys";
import TeamDropdown from "@/components/StickyNote/internal/TeamDropdown/TeamDropdown.vue";
import AttributeChip from "@/components/chip/AttributeChip.vue";
import { useTeamStore } from "@/store/team";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);

const team = computed(() => useTeamStore().findTeam({ id: card.teamId ?? undefined }));
</script>

<template>
  <AttributeChip
    name="team-select-chip"
    :text="team?.name"
    text-placeholder="Team"
    :tooltip="$t('action.team')"
  >
    <TeamDropdown />
  </AttributeChip>
</template>
